export function getGachaProfileWallet<T extends { address: string }>(
  wallets: readonly T[],
  profileAddress: string | undefined,
): T | undefined {
  if (!profileAddress?.trim()) return undefined
  return wallets.find(
    (wallet) => wallet.address.toLowerCase() === profileAddress.toLowerCase(),
  )
}
